import { Controller } from "@hotwired/stimulus"

// Enter sends the message, Shift+Enter inserts a newline (default
// textarea behavior); Enter while composing (an IME picking a candidate,
// e.g. Japanese/Chinese input) is ignored, since that Enter confirms the
// candidate, not the message. There is no client-side "busy" state to
// track: the server is the source of truth (a second send while the
// reply is still running comes back 422), and the textarea/alert only
// clear on a successful submit — a rejected one leaves both in place so
// nothing typed is lost and the error stays visible.
export default class extends Controller {
  static targets = ["input", "submit"]

  keydown(event) {
    if (event.key !== "Enter" || event.shiftKey || event.isComposing) return
    event.preventDefault()
    this.element.requestSubmit()
  }

  reset(event) {
    if (!event.detail?.success) return
    if (this.hasInputTarget) this.inputTarget.value = ""
    const alert = this.element.querySelector("#assistant_composer_alert")
    if (alert) alert.innerHTML = ""
  }
}
